module.exports = __webpack_public_path__ + "static/media/3동물권-서로를보다.9a188b5d.mp3";